// src/pages/solusi/FormKonsultasi.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FormKonsultasi = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    namaLengkap: '',
    email: '',
    telepon: '',
    namaPerusahaan: '',
    jenisIndustri: '',
    deskripsiProyek: '',
    targetWaktu: '',
    anggaran: '',
    catatanTambahan: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState(''); // 'success', 'error', ''

  const jenisIndustriOptions = [
    'Pilih Industri',
    'Pertanian',
    'Rumah Tangga / Smart Home',
    'Manufaktur',
    'Kesehatan',
    'Lingkungan',
    'Ritel',
    'Transportasi',
    'Pendidikan',
    'Lainnya',
  ];

  const targetWaktuOptions = [
    'Pilih Jangka Waktu',
    '< 3 Bulan',
    '3 - 6 Bulan',
    '6 - 12 Bulan',
    '> 12 Bulan',
  ];

  const anggaranOptions = [
    'Pilih Anggaran',
    '< Rp 10 Juta',
    'Rp 10 Juta - Rp 50 Juta',
    'Rp 50 Juta - Rp 200 Juta',
    '> Rp 200 Juta',
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    }
  };

  const validateForm = () => {
    let errors = {};
    if (!formData.namaLengkap) errors.namaLengkap = 'Nama lengkap wajib diisi.';
    if (!formData.email) {
      errors.email = 'Email wajib diisi.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Format email tidak valid.';
    }
    if (!formData.telepon) errors.telepon = 'Nomor telepon wajib diisi.';
    if (!formData.deskripsiProyek) errors.deskripsiProyek = 'Deskripsi proyek wajib diisi.';
    if (formData.jenisIndustri === 'Pilih Industri') errors.jenisIndustri = 'Jenis industri wajib dipilih.';
    if (formData.targetWaktu === 'Pilih Jangka Waktu') errors.targetWaktu = 'Target waktu wajib dipilih.';
    if (formData.anggaran === 'Pilih Anggaran') errors.anggaran = 'Anggaran wajib dipilih.';
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setFormStatus('error');
      alert('Mohon lengkapi semua bidang yang wajib diisi dengan benar.');
      return;
    }

    setIsSubmitting(true);
    setFormStatus('submitting');

    try {
      // Simulasi pengiriman form (ganti dengan API endpoint Anda)
      console.log('Mengirim data konsultasi:', formData);
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Delay 2 detik simulasi

      // Di sini Anda akan mengirim data ke backend Anda
      // const response = await fetch('/api/konsultasi', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(formData),
      // });
      // const result = await response.json();

      // if (response.ok) {
        setFormStatus('success');
        alert('Formulir konsultasi berhasil dikirim! Kami akan segera menghubungi Anda.');
        setFormData({ // Reset form
          namaLengkap: '',
          email: '',
          telepon: '',
          namaPerusahaan: '',
          jenisIndustri: 'Pilih Industri',
          deskripsiProyek: '',
          targetWaktu: 'Pilih Jangka Waktu',
          anggaran: 'Pilih Anggaran',
          catatanTambahan: '',
        });
      // } else {
      //   setFormStatus('error');
      //   alert('Terjadi kesalahan saat mengirim formulir. Mohon coba lagi nanti.');
      // }
    } catch (error) {
      console.error('Error sending consultation form:', error);
      setFormStatus('error');
      alert('Terjadi kesalahan saat mengirim formulir. Mohon coba lagi nanti.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen py-16 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Hero Section Konsultasi */}
        <section className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-blue-700 dark:text-blue-400 leading-tight mb-4">
            Konsultasi Proyek IoT
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 dark:text-gray-300">
            Dapatkan saran ahli dan solusi kustom untuk ide proyek IoT Anda. Isi formulir di bawah ini dan kami akan segera menghubungi Anda.
          </p>
        </section>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Kolom Kiri: Formulir Proyek */}
          <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">Detail Proyek Anda</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Informasi Kontak */}
              <div>
                <label htmlFor="namaLengkap" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nama Lengkap <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  id="namaLengkap"
                  name="namaLengkap"
                  value={formData.namaLengkap}
                  onChange={handleChange}
                  className={`mt-1 block w-full px-4 py-2 border ${formErrors.namaLengkap ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100`}
                  required
                />
                {formErrors.namaLengkap && <p className="text-red-500 text-xs mt-1">{formErrors.namaLengkap}</p>}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Email <span className="text-red-500">*</span></label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`mt-1 block w-full px-4 py-2 border ${formErrors.email ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100`}
                    required
                  />
                  {formErrors.email && <p className="text-red-500 text-xs mt-1">{formErrors.email}</p>}
                </div>
                <div>
                  <label htmlFor="telepon" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nomor Telepon <span className="text-red-500">*</span></label>
                  <input
                    type="tel"
                    id="telepon"
                    name="telepon"
                    value={formData.telepon}
                    onChange={handleChange}
                    className={`mt-1 block w-full px-4 py-2 border ${formErrors.telepon ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100`}
                    required
                  />
                  {formErrors.telepon && <p className="text-red-500 text-xs mt-1">{formErrors.telepon}</p>}
                </div>
              </div>
              {/* Informasi Proyek */}
              <div>
                <label htmlFor="namaPerusahaan" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nama Perusahaan / Organisasi (Opsional)</label>
                <input
                  type="text"
                  id="namaPerusahaan"
                  name="namaPerusahaan"
                  value={formData.namaPerusahaan}
                  onChange={handleChange}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100"
                  placeholder="Opsional"
                />
              </div>
              <div>
                <label htmlFor="jenisIndustri" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Jenis Industri <span className="text-red-500">*</span></label>
                <select
                  id="jenisIndustri"
                  name="jenisIndustri"
                  value={formData.jenisIndustri}
                  onChange={handleChange}
                  className={`mt-1 block w-full px-4 py-2 border ${formErrors.jenisIndustri ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100`}
                  required
                >
                  {jenisIndustriOptions.map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
                {formErrors.jenisIndustri && <p className="text-red-500 text-xs mt-1">{formErrors.jenisIndustri}</p>}
              </div>
              <div>
                <label htmlFor="deskripsiProyek" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Deskripsi Singkat Proyek / Ide Anda <span className="text-red-500">*</span></label>
                <textarea
                  id="deskripsiProyek"
                  name="deskripsiProyek"
                  rows="5"
                  value={formData.deskripsiProyek}
                  onChange={handleChange}
                  className={`mt-1 block w-full px-4 py-2 border ${formErrors.deskripsiProyek ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100`}
                  placeholder="Jelaskan secara singkat ide atau kebutuhan proyek IoT Anda."
                  required
                ></textarea>
                {formErrors.deskripsiProyek && <p className="text-red-500 text-xs mt-1">{formErrors.deskripsiProyek}</p>}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="targetWaktu" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Target Waktu Implementasi <span className="text-red-500">*</span></label>
                  <select
                    id="targetWaktu"
                    name="targetWaktu"
                    value={formData.targetWaktu}
                    onChange={handleChange}
                    className={`mt-1 block w-full px-4 py-2 border ${formErrors.targetWaktu ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100`}
                    required
                  >
                    {targetWaktuOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  {formErrors.targetWaktu && <p className="text-red-500 text-xs mt-1">{formErrors.targetWaktu}</p>}
                </div>
                <div>
                  <label htmlFor="anggaran" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Estimasi Anggaran <span className="text-red-500">*</span></label>
                  <select
                    id="anggaran"
                    name="anggaran"
                    value={formData.anggaran}
                    onChange={handleChange}
                    className={`mt-1 block w-full px-4 py-2 border ${formErrors.anggaran ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100`}
                    required
                  >
                    {anggaranOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  {formErrors.anggaran && <p className="text-red-500 text-xs mt-1">{formErrors.anggaran}</p>}
                </div>
              </div>
              <div>
                <label htmlFor="catatanTambahan" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Catatan Tambahan (Opsional)</label>
                <textarea
                  id="catatanTambahan"
                  name="catatanTambahan"
                  rows="3"
                  value={formData.catatanTambahan}
                  onChange={handleChange}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100"
                  placeholder="Informasi lain yang relevan."
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white font-semibold py-3 rounded-lg hover:bg-blue-700 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Mengirim...' : 'Kirim Konsultasi'}
              </button>

              {formStatus === 'success' && (
                <p className="text-green-600 dark:text-green-400 text-center mt-4">Formulir konsultasi berhasil dikirim! Kami akan segera menghubungi Anda.</p>
              )}
              {formStatus === 'error' && (
                <p className="text-red-600 dark:text-red-400 text-center mt-4">Gagal mengirim formulir. Mohon coba lagi.</p>
              )}
            </form>
          </div>

          {/* Kolom Kanan: Proses Konsultasi & Kontak Alternatif */}
          <div className="space-y-8">
            {/* Proses Konsultasi */}
            <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">Proses Konsultasi Kami</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0 text-blue-500 dark:text-blue-300 text-2xl mr-3">1.</div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-gray-100">Pengajuan Formulir</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Anda mengisi formulir di samping dengan detail proyek Anda.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 text-green-500 dark:text-green-300 text-2xl mr-3">2.</div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-gray-100">Evaluasi Awal</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Tim ahli kami akan meninjau informasi yang Anda berikan.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 text-purple-500 dark:text-purple-300 text-2xl mr-3">3.</div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-gray-100">Sesi Diskusi Mendalam</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Kami akan menghubungi Anda untuk sesi diskusi lebih lanjut via telepon/video call.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 text-yellow-500 dark:text-yellow-300 text-2xl mr-3">4.</div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-gray-100">Penawaran Solusi</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Kami menyajikan proposal solusi dan estimasi biaya.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Informasi Kontak Alternatif */}
            <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">Butuh Respon Cepat?</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Untuk pertanyaan mendesak, Anda bisa menghubungi kami langsung:
              </p>
              <div className="space-y-4">
                <div className="flex items-center text-gray-700 dark:text-gray-300">
                  <span className="text-green-500 dark:text-green-300 text-2xl mr-3">💬</span>
                  <div>
                    <p className="font-semibold">WhatsApp:</p>
                    <a href="https://api.whatsapp.com/send/?phone=6285122019659&text&type=phone_number&app_absent=0" className="hover:underline text-blue-500 dark:text-blue-300">Chat Langsung via WhatsApp</a>
                  </div>
                </div>
                <div className="flex items-center text-gray-700 dark:text-gray-300">
                  <span className="text-blue-500 dark:text-blue-300 text-2xl mr-3">📧</span>
                  <div>
                    <p className="font-semibold">Email:</p>
                    <a href="mailto:budi@solusipemetaanpasti.my.id" className="hover:underline">budi@solusipemetaanpasti.my.id</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FormKonsultasi;